module.exports = __webpack_public_path__ + "static/media/river-landing.61b9a8da.jpeg";